module.exports = __webpack_public_path__ + "static/media/bottom_banner_12_1.3359794e.png";